import { useFormik } from "formik"

export function useProjectsFilterFormik() {
  const formik = useFormik({
    initialValues: {
      name: "",
      state: "active",
      clients: [],
      users: [],
      groups: [],
      billable: undefined,
    },
    onSubmit: () => {},
  })

  return formik
}
